// Tabla compartida de colores RGB para todas las funciones
const STATUS_COLORS_RGB = {
  go: { r: 0, g: 200, b: 0 },
  salimos: { r: 0, g: 123, b: 255 },
  volvemos: { r: 255, g: 215, b: 0 },
  fin: { r: 255, g: 0, b: 0 }
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'go':
      return 'bg-[rgba(0,200,0,0.25)]'; // verde suave
    case 'salimos':
      return 'bg-[rgba(0,123,255,0.25)]'; // azul suave
    case 'volvemos':
      return 'bg-[rgba(255,215,0,0.25)]'; // amarillo suave
    case 'fin':
      return 'bg-[rgba(255,0,0,0.25)]'; // rojo suave
    default:
      return ''; // sin color
  }
};

export const getDisplayColor = (status, theme) => {
  const color = STATUS_COLORS_RGB[status];
  if (!color) return '';

  if (theme === 'light') {
    return `rgba(${color.r}, ${color.g}, ${color.b}, 0.25)`;
  }

  // Dark: aclarar RGB con porcentaje según status + elevar alfa a 0.50
  const percentage = (status === 'salimos') ? 0.45 : 0.35;
  const lighten = (v) => Math.round(v + (255 - v) * percentage);
  return `rgba(${lighten(color.r)}, ${lighten(color.g)}, ${lighten(color.b)}, 0.50)`;
};
